import React from "react";
import { IconProps } from "./IconProps";

const ClockIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2C8.41775 2 6.87103 2.46919 5.55544 3.34824C4.23985 4.22729 3.21447 5.47672 2.60897 6.93853C2.00347 8.40034 1.84504 10.0089 2.15372 11.5607C2.4624 13.1126 3.22433 14.538 4.34315 15.6569C5.46197 16.7757 6.88743 17.5376 8.43928 17.8463C9.99113 18.155 11.5997 17.9965 13.0615 17.391C14.5233 16.7855 15.7727 15.7602 16.6518 14.4446C17.5308 13.129 18 11.5822 18 10C17.9978 7.87895 17.1542 5.84542 15.6544 4.34562C14.1546 2.84581 12.121 2.00224 10 2ZM10 16.7692C8.66117 16.7692 7.35241 16.3722 6.23922 15.6284C5.12603 14.8846 4.2584 13.8274 3.74605 12.5905C3.2337 11.3536 3.09965 9.99249 3.36084 8.67939C3.62203 7.36629 4.26674 6.16012 5.21343 5.21343C6.16013 4.26674 7.36629 3.62203 8.67939 3.36084C9.99249 3.09965 11.3536 3.2337 12.5905 3.74605C13.8274 4.25839 14.8846 5.12602 15.6284 6.23922C16.3722 7.35241 16.7692 8.66117 16.7692 10C16.7672 11.7947 16.0534 13.5153 14.7843 14.7843C13.5153 16.0534 11.7947 16.7672 10 16.7692ZM14.9231 10C14.9231 10.1632 14.8582 10.3197 14.7428 10.4351C14.6274 10.5505 14.4709 10.6154 14.3077 10.6154H10C9.83679 10.6154 9.68027 10.5505 9.56486 10.4351C9.44945 10.3197 9.38462 10.1632 9.38462 10V5.69231C9.38462 5.5291 9.44945 5.37257 9.56486 5.25716C9.68027 5.14176 9.83679 5.07692 10 5.07692C10.1632 5.07692 10.3197 5.14176 10.4351 5.25716C10.5506 5.37257 10.6154 5.5291 10.6154 5.69231V9.38461H14.3077C14.4709 9.38461 14.6274 9.44945 14.7428 9.56486C14.8582 9.68026 14.9231 9.83679 14.9231 10Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10.5 5.625C10.5 5.34886 10.2761 5.125 10 5.125C9.72386 5.125 9.5 5.34886 9.5 5.625V10C9.5 10.2761 9.72386 10.5 10 10.5H14.375C14.6511 10.5 14.875 10.2761 14.875 10C14.875 9.72386 14.6511 9.5 14.375 9.5H10.5V5.625Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ClockIcon;
